export default __webpack_public_path__ + "static/media/vip-icon-active.2be557ad.webp";